import { CapoPlugin } from "/home/runner/work/hub/hub/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];